// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zjPyE{position:relative;display:inline-flex;max-width:100%;min-width:0}.fGcXv{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap}.XIYfD{flex:0 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:pre;user-select:none}.x5tRo{flex:0 0 auto;white-space:pre;user-select:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zjPyE`,
	"text": `fGcXv`,
	"head": `XIYfD`,
	"tail": `x5tRo`
};
export default ___CSS_LOADER_EXPORT___;
